import { ChangeEvent, ComponentPropsWithoutRef, MouseEvent, ReactNode } from 'react';
import { CheckboxWrapper, FakeCheckbox, Input } from './styles';

export type CheckboxClickEventType = MouseEvent<HTMLInputElement>;

export type CheckboxChangeEventType = ChangeEvent<HTMLInputElement>;

export type CheckboxProps = {
  checked?: boolean;
  onChange?: (event: CheckboxChangeEventType) => void;
  label?: ReactNode;
  disabled?: boolean;
  indeterminate?: boolean;
  id?: string;
  onClick?: (event: CheckboxClickEventType) => void;
  error?: string;
  apiError?: string;
} & ComponentPropsWithoutRef<'input'>;

export const Checkbox = ({
  id,
  checked,
  onChange,
  onClick,
  disabled,
  label,
  indeterminate = false,
  error,
  apiError,
  ...rest
}: CheckboxProps) => {
  const hasError = !!error || !!apiError;

  return (
    <CheckboxWrapper>
      <Input
        id={id}
        type='checkbox'
        checked={checked || indeterminate}
        onChange={onChange}
        disabled={disabled}
        onClick={onClick}
        indeterminate={indeterminate}
        {...rest}
      />
      <FakeCheckbox disabled={disabled} hasError={hasError} hasLabel={!!label} />
      {label}
    </CheckboxWrapper>
  );
};
